import moment from 'moment';
import React, { useEffect, useState } from 'react';

const useCountdownTimer = (initialSeconds) => {
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [seconds]);

    const resetTimer = (newSeconds) => {
        setSeconds(newSeconds);
    };

    const formatTime = (time) => {
        const mins = Math.floor(time / 60);
        const secs = time % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    return { time: formatTime(seconds), resetTimer, seconds };
};

export default useCountdownTimer;
